// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__TUqw_","validationTips":"StatementDescriptor_validationTips__3r5zi"};